import { TransitionStatus } from "react-transition-group/Transition";

type Transition<T> = { [key in TransitionStatus]: T };

type Anime = {
  transition: string;
  opacity: number;
} & React.CSSProperties;

type TransformAnime = {
  transform: string;
} & Anime;

/**
 * @param speed 単位: 秒
 */
const transitionAll = (speed: number) => `all ${speed}s ease`;

/**
 * フェードアニメーション
 */
export const createFadingAnime = (speed: number): Transition<Anime> => {
  return {
    entering: { transition: `all ${speed}s`, opacity: 0 },
    entered: { transition: `all ${speed}s`, opacity: 1 },
    exiting: { transition: `all ${speed}s`, opacity: 0 },
    exited: { transition: `all ${speed}s`, opacity: 0 },
    unmounted: { transition: "", opacity: 0 },
  };
};

export type FadingAnime = ReturnType<typeof createFadingAnime>;

/**
 * bottomからスライドアニメーション
 */
export const createSlidingToBottomAnime = (): Transition<TransformAnime> => {
  const transition = transitionAll(0.5);
  const transformEnter = "translateY(0px)";
  const transformExit = "translateY(100px)";
  return {
    entering: {
      transition,
      transform: transformEnter,
      opacity: 0,
    },
    entered: {
      transition,
      transform: transformEnter,
      opacity: 1,
    },
    exiting: {
      transition,
      transform: transformEnter,
      opacity: 1,
    },
    exited: {
      transition,
      transform: transformExit,
      opacity: 0,
    },
    unmounted: { transition: "", transform: "", opacity: 0 },
  };
};

/**
 * 伸縮アニメーション
 */
export const createExpandingHeightAnime = (): Transition<TransformAnime> => {
  const transition = transitionAll(0.5);
  return {
    entering: {
      transition,
      transform: "scaleY(0)",
      opacity: 0,
    },
    entered: {
      transition,
      transform: "scaleY(1)",
      opacity: 1,
    },
    exiting: {
      transition,
      transform: "scaleY(1)",
      opacity: 1,
    },
    exited: {
      transition,
      transform: "scaleY(0)",
      opacity: 0,
    },
    unmounted: { transition: "", transform: "", opacity: 0 },
  };
};

/**
 * ドロップダウンアニメーション
 */
export const createDroppingDownAnime = (
  speed: number,
  pos: number
): Transition<TransformAnime> => {
  return {
    entering: {
      transition: `all ${speed}s`,
      transform: `translateY(${pos}px)`,
      opacity: 0,
    },
    entered: {
      transition: `all ${speed}s`,
      transform: "translateY(0px)",
      opacity: 1,
    },
    exiting: {
      transition: `all ${speed}s`,
      transform: `translateY(${pos}px)`,
      opacity: 0,
    },
    exited: {
      transition: `all ${speed}s`,
      transform: `translateY(${pos}px)`,
      opacity: 0,
    },
    unmounted: { transition: "", transform: "", opacity: 0 },
  };
};
